import { ApolloProvider } from '@apollo/client/react';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';

import App from './App.tsx';
import './index.css';

import { ThemeProvider } from '@/components/theme-provider';
import ErrorFallback from '@/ErrorFallback';
import { createApolloClient } from '@/lib/apolloClient';
import { msalConfig } from '@/lib/msalConfig';

// Create MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL
await msalInstance.initialize();

// Handle redirect promise - this is critical for handling the redirect from Microsoft login
await msalInstance.handleRedirectPromise().catch((error: unknown) => {
  console.error('Error handling redirect:', error);
});

// Create Apollo Client instance for GraphQL
const apolloClient = createApolloClient();

Sentry.init({
  dsn: 'https://2a8806e9c9bb3fc3c7ba0dbc90f6195b@o4508936149139456.ingest.us.sentry.io/4510505202483200',
  sendDefaultPii: true
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element.');

createRoot(rootElement).render(
  <StrictMode>
    <MsalProvider instance={msalInstance}>
      <ApolloProvider client={apolloClient}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <ThemeProvider storageKey="vite-ui-theme">
            <App />
          </ThemeProvider>
        </ErrorBoundary>
      </ApolloProvider>
    </MsalProvider>
  </StrictMode>
);
